import { getItem } from '@/utils/localstorage';
import { useMemo } from 'react';

const useAppRoutes = () => {
  const site = getItem('site');
  const routes = useMemo(
    () => ({
      landingPage: () => '/',
      support: () => '/support',
      other: () => '/other',
      otherSuccess: () => '/other/success',
      error: () => '/error',
      logout: () => '/logout',
      errorNoCameraAccess: () => '/error/no-camera-access',
      errorAccessDenied: () => '/error/access-denied',
      errorSite404: () => '/error/site-404',
      email: () => `/${site}/email`,
      axs: () => `/${site}/axs`,
      paciolan: (campPath: string, pacToken: string, redirectUrl: string) =>
        `/${site}/${campPath}/paciolan?pacToken=${encodeURIComponent(pacToken)}&redirectUrl=${encodeURIComponent(redirectUrl)}`,
      emailCheck: () => `/${site}/email/check`,
      emailVerificationCode: (verificationCode: string) =>
        `/${site}/email/verify/${verificationCode}`,
      qualityCheck: () => `/${site}/quality/check`,
      faceRecognition: () => `/${site}/face-recognition`,
      phone: () => `/${site}/phone`,
      codeVerify: () => `/${site}/code/verify`,
      oAuthVerify: () => `/${site}/oauth/verify`,
      site: () => `/${site}`,
      siteCampaigns: () => `/${site}/campaigns`,
      siteCampaignsSelfie: () => `/${site}/selfie`,
      siteCampaignSelfie: (campPath: string) => `/${site}/${campPath}/selfie`,
      siteCampaign: (campPath: string) => `/${site}/${campPath}`,
      siteCampaignSteps: (campPath: string) => `/${site}/${campPath}/steps`,
      siteCampaignEnrollmentConfirmation: (campPath: string) =>
        `/${site}/${campPath}/enrollment-confirmation`,
      siteCampaignIdVerification: (campPath: string) => `/${site}/${campPath}/id`,
      siteCampaignPayment: (campPath: string) => `/${site}/${campPath}/payment`,
      siteCampaignLinkAccount: (campPath: string) => `/${site}/${campPath}/link-account`,
      siteCampaignLinkedAccount: (campPath: string) => `/${site}/${campPath}/account-linked`,
      // siteCampaignPointOfSale: (campPath: string, pointOfSale = 'lava') =>
      //   `/${pathSegment}/${campPath}/${pointOfSale}`,
      profile: () => `/${site}/profile`,
      profileEmailChange: () => `/${site}/profile/email/change`,
      profilePhoneChange: () => `/${site}/profile/phone/change`,
      profilePhoneCodeVerify: () => `/${site}/profile/phone/code/verify`,
      profileNameChange: () => `/${site}/profile/name/change`,
      selfie: () => `/${site}/profile/selfie`,
      selfieManage: () => `/${site}/profile/selfie/manage`,
      selfieAdd: () => `/${site}/profile/selfie/add`,
      payment: () => `/${site}/profile/payment`,
      paymentManage: () => `/${site}/profile/payment/manage`,
      paymentAdd: (campPath?: string) => `/${site}/${campPath || 'profile'}/payment/add`
    }),
    [site]
  );

  return routes;
};

export default useAppRoutes;
